import React from 'react'
import { useQuery } from '@tanstack/react-query'

import { Box, Grid, Typography } from '@the-platform-group/component-library'
import { Button } from '@the-platform-group/component-library/Button'

import Spinner from 'components/Spinner'
import CustomerAuthorizationModal from 'components/CustomerModals/components/CustomerAuthorizationModal'
import UserNotifications from './components/UserNotifications'
import UserCustomers from './components/UserCustomers'
import UserFdsadminDetails from './components/UserFdsadminDetails'
import { getUser } from 'services/users'
import { useSessionState } from 'contexts/Session'
import useCustomerAuthModal from './hooks/useCustomerAuthModal'
import useUserForm from 'components/UserForm/useUserForm'
import useSyncUser from 'pages/Users/hooks/useSyncUser'
import { isAdmin } from 'utils/auth'
import { USER_QUERY_KEY } from 'pages/Users/hooks/useUsers'

function UserDetailComponent() {
  const { currentUser } = useSessionState()
  const { userId, handleOpen, handleClose, open, onSave, isSaving } = useCustomerAuthModal()
  const { data: user, isPending: isLoading } = useQuery({
    queryKey: [USER_QUERY_KEY, userId],
    queryFn: () => getUser(userId),
    enabled: !!userId,
    refetchOnWindowFocus: false,
    throwOnError: true,
    // Disable structural sharing to ensure fresh data is used when users are edited
    // React Query's structural sharing was preventing updated user data from showing
    // after invalidateQueries() because it considered the user list "structurally similar"
    structuralSharing: false,
  })

  const { handleUserEdit, getUserFormModal } = useUserForm()
  const { syncUser, isSyncing } = useSyncUser()
  const usernameSerials = user?.userFdsadminDetails?.map(detail => detail.usernameSerial)

  return isLoading || !user ? (
    <Spinner />
  ) : (
    <>
      <Grid container justifyContent="space-between" alignItems="flex-end">
        <Grid item xs={6}>
          <Typography variant="h4" component="h1" gutterBottom>
            {[user.firstName, user.lastName].join(' ')}
          </Typography>
          <Typography variant="subtitle2" component="h1">
            {user.email}
          </Typography>
          <Typography variant="subtitle2" component="h3">
            Role: {user.role}
          </Typography>
        </Grid>
        <Grid item container justifyContent="flex-end" alignItems="center" spacing={1} xs="auto">
          {isAdmin(currentUser) ? (
            <>
              <Grid item>
                <Button onClick={() => handleUserEdit(user)}>Edit</Button>
              </Grid>
              <Grid item>
                <Button onClick={handleOpen}>Add Customer to User</Button>
              </Grid>
              <Grid item>
                <Button
                  disabled={!usernameSerials?.length}
                  isLoading={isSyncing}
                  onClick={() => syncUser(usernameSerials)}
                >
                  Sync User
                </Button>
              </Grid>

              {getUserFormModal()}
              <CustomerAuthorizationModal
                isOpen={open}
                onClose={handleClose}
                onSave={onSave}
                isSaving={isSaving}
              />
            </>
          ) : null}
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <UserCustomers user={user} />
        </Grid>
      </Grid>
      <br />

      <Box sx={{ mb: 2 }}>
        <UserFdsadminDetails
          details={user.userFdsadminDetails}
          userId={user.id}
          canDelete={isAdmin(currentUser)}
        />
      </Box>
      <br />

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <UserNotifications user={user} />
        </Grid>
      </Grid>
      <br />
    </>
  )
}

export default UserDetailComponent
